import React, { useEffect, useState } from 'react'
import DynamicActionBar from '../../Common/DynamicActionBar'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ACTIONS } from '../../redux/actions';
import { Api } from '../../Service/api';
import { ErrorToast } from '../../Common/Toast';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Pagination from '../../Common/Pagination';
import { dynamicSequence } from '../../helper/dynamicSequence';
import DynamicQuestionSet from '../../Component/ManuallyGenerate/CheckboxList';
import { cleanTableBrTags, convertIntoMath, madeFinalObject, noColumnInQuestion, XPattern, splitRectifyQuestion } from '../../helper/madeFinalObject';
import QuestionReportModel from '../../Common/QuestionReport';
import { Button } from '../../Common/Button';

const QuestionSection = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let { sectionIndex, divisionIndex, qtypeId, chappterId, replaceId, EditId } = useParams();

    const selectedData = useSelector((state) => state?.SelectedDetail?.Data);
    let previousSelectedData = selectedData?.sections_info?.[sectionIndex]?.divisions?.[divisionIndex]?.question_data

    const [selectedOptions, setSelectedOptions] = useState([false, false])
    const [questions, setQuestions] = useState([])

    const [selectedQuestions, setSelectedQuestions] = useState([])
    const [questionData, setQuestionData] = useState([])
    const [selectedArray, setSelectedArray] = useState([]);
    const [andId, setAndId] = useState(0);
    const [isReportModelOpen, setIsReportModelOpen] = useState(false)
    const [queReportData, setQueReportData] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const questionsPerPage = 20







    const handleBackClick = (e) => {
        e.preventDefault();
        onSavePress();
        navigate(-1);
    };

    const handleToggleChange = (newSelectedOptions) => {
        setSelectedOptions(newSelectedOptions)
        setAndId(0);

    }

    const actions = [
        {
            type: 'toggle',
            options: [
                { label: 'AND', color: 'green' },
                { label: 'OR', color: 'orange' }
            ],
            selectedOptions: selectedOptions,
            onChange: handleToggleChange
        }]

    const _getQuestions = async (page = 1) => {

        dispatch(ACTIONS.startLoading())
        try {
            let payload = {
                standard: selectedData?.standard_id,
                subject: selectedData?.subject_id,
                qType: qtypeId,
                chapter: chappterId,
                limit: questionsPerPage,
                offset: page,
            }
            const { data } = await Api.GetQuestion(payload)
            const res = JSON.parse(data);
            if (res?.status === 200) {
                setQuestions(res?.data)

                let newData = res?.data?.map(
                    (ele, index) => {
                        let isSelected = false;
                        let isOrSelected = false;
                        let isOldSelected = false;
                        let isFreeze = false;
                        let isAndSelected = false;

                        selectedData?.sections_info?.forEach((section) => {
                            section?.divisions?.forEach((division) => {
                                division?.question_data?.forEach((item) => {
                                    if (item?.id == ele?.id) {
                                        if (replaceId) {
                                            if (section?.section_id == Number(sectionIndex) + 1 || division?.division_id == Number(divisionIndex) + 1) {

                                                isFreeze = true;
                                            }
                                        }

                                        if (
                                            section?.section_id !=
                                            Number(sectionIndex) + 1 ||
                                            division?.division_id !=
                                            Number(divisionIndex) + 1
                                        ) {
                                            isFreeze = true;


                                        }
                                        isSelected = true;
                                        isOldSelected = true;
                                        if (item?.isOr) {
                                            isOrSelected = true;
                                        }
                                        if (item?.isAnd) {
                                            isAndSelected = true;
                                        }
                                    }
                                });
                            });
                        });

                        return {
                            ...ele,
                            selected: isSelected,
                            isOr: isOrSelected,
                            isOld: isOldSelected,
                            isFreeze: isFreeze,
                            isAnd: isAndSelected,
                            isAndData: [],
                        };
                    },
                );

                let onlySelectedData = res?.data?.filter((item) => {
                    return item?.selected;
                });
                setSelectedArray(onlySelectedData);

                setQuestionData(newData);

                setTotalPages(Math.ceil(res?.totalCount / questionsPerPage))
            } else {
                ErrorToast(res?.message);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }


    useEffect(() => {
        _getQuestions(currentPage)
    }, [currentPage])

    const handlePageChange = (newPage) => {
        onSavePress();
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage)
        }
    }

    const onSavePress = async () => {
        console.log('object :>> ');
        try {
            let qData = [];
            let orIndex = 0;
            // let andId = 0;

            const sectionID = Number(sectionIndex) + 1;
            const divisionID = Number(divisionIndex) + 1;
            //   const {sectionID, divisionID} = props?.route?.params;

            const oldUnselected = questionData
                .filter(item => !item.selected && item.isOld)
                .map(it => it.id);

            selectedData?.sections_info?.forEach(section => {
                if (section.section_id === sectionID) {
                    section?.divisions?.forEach(division => {
                        if (division.division_id === divisionID) {
                            qData =
                                division?.question_data?.filter(
                                    ele => !oldUnselected.includes(ele.id),
                                ) || [];
                        }
                    });
                }
            });

            const selectedDatas = questionData.filter(
                item => item.selected && !item.isOld,
            );

            const selectedDataArr = selectedArray.filter(item => !item.isOld);

            console.log('selectedData :>> ', selectedDataArr);

            const generateQuestionId = () => {
                return (qData?.length + 1 - orIndex).toString();
            };

            selectedDataArr.forEach(item => {
                const subID = Math.floor(Math.random() * 1000);
                // if (item.isAnd) {
                //     andId = andId + 1;
                // } else {
                //     andId = 0;
                // }

                if (item?.finalquestion.includes('(x1).')) {
                    const subQuestions = splitRectifyQuestion(item, qData.length, false);
                    qData.push(...subQuestions);
                } else if (
                    item?.perfact_metch?.length > 0 &&
                    !noColumnInQuestion.includes(item.qtype)
                ) {
                    item.perfact_metch.forEach((ele, ind) => {
                        qData.push({
                            ...item,
                            ...(ind === 0 && { paragraph: convertIntoMath(item?.finalquestion?.trim()) }),
                            question_id: generateQuestionId(),
                            questionLeft: convertIntoMath(ele?.finalquestion),
                            questionRight: convertIntoMath(ele?.finalanswer),
                            rightAnswer: convertIntoMath(ele?.finalrightAnswer),
                            id: item.id,
                            answer: convertIntoMath(item?.answer),
                            question: '',
                            que_id: item?.que_id,
                            html_tag: item.html_tag || item?.html_question,
                            andId: item?.andId,
                            perfact_metch: [],
                        });
                    });
                } else {
                    const pushingItem = {
                        ...item,
                        question_id: generateQuestionId(),
                        question: item.question,
                        id: item.id,
                        qType: item.qtype,
                        html_tag: item.html_tag || item?.html_question,
                        andId: item?.andId,
                        answer: convertIntoMath(item?.finalAnswer),
                        ...((item.option1 || item.option1_img) &&
                            (item.option2 || item.option2_img) &&
                            (item.option3 || item.option3_img) &&
                            (item.option4 || item.option4_img) && {
                            answers: [
                                { answer: convertIntoMath(item.option1 || ''), imgAnswers: item.option1_img },
                                { answer: convertIntoMath(item.option2 || ''), imgAnswers: item.option2_img },
                                { answer: convertIntoMath(item.option3 || ''), imgAnswers: item.option3_img },
                                { answer: convertIntoMath(item.option4 || ''), imgAnswers: item.option4_img },
                            ],
                        }),
                        ...((item.option1 || item.option1_img) &&
                            (item.option2 || item.option2_img) &&
                            (item.option3 || item.option3_img) &&
                            (item.option4 || item.option4_img) && {
                            finalAnswers: [
                                { answer: convertIntoMath(item.finaloption1 || ''), imgAnswers: item.option1_img },
                                { answer: convertIntoMath(item.finaloption2 || ''), imgAnswers: item.option2_img },
                                { answer: convertIntoMath(item.finaloption3 || ''), imgAnswers: item.option3_img },
                                { answer: convertIntoMath(item.finaloption4 || ''), imgAnswers: item.option4_img },
                            ],
                        }),
                    };

                    qData.push(pushingItem);
                }
            });


            const updatedPayload = {
                ...selectedData,
                sections_info: selectedData?.sections_info?.map(section => {
                    if (section.section_id === sectionID) {
                        return {
                            ...section,
                            divisions: section?.divisions?.map(division => {
                                if (division.division_id === divisionID) {
                                    return {
                                        ...division,
                                        question_data: qData,
                                    };
                                }
                                return division;
                            }),
                        };
                    }
                    return section;
                }),
            };



            let dataObject = dynamicSequence(updatedPayload.sections_info);


            let finalOut = {
                ...selectedData,
                sections_info: dataObject,
            };



            dispatch(ACTIONS.getSelectedData(finalOut))
        } catch (error) {
            // Handle error
        }
    };
    const handleSelectionChange = async (selected, id) => {
        const isSelected = selected.some(item => item.id === id)
        setSelectedQuestions(isSelected)

    }

    const handleReport = (question) => {
        setQueReportData(question)
        setIsReportModelOpen(true);
        // Add your report handling logic here
    }

    return (
        <div>
            <DynamicActionBar
                showArrowLeft
                backButtonLabel={selectedData?.subject_name}
                onBackClick={handleBackClick}
                actions={actions}
            />
            <DynamicQuestionSet
                selectedArray={selectedArray}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                questions={questionData}
                onSelectionChange={handleSelectionChange}
                onReport={handleReport}
                setSelectedArray={setSelectedArray}
                setQuestions={setQuestionData}
                andId={andId}
                setAndId={setAndId}
                selectedData={selectedData}
            />
            {questions &&
                <div className="sticky bottom-0 left-0 right-0 p-4 border-t flex justify-between flex-row bg-[#F6F7F9]">
                    <div></div>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                    />
                    <div style={{ width: "60px" }}>
                        <Button
                            id=""
                            type="button"
                            label={"Save"}
                            onClick={handleBackClick}
                        />
                    </div>
                </div>
            }
            <QuestionReportModel
                isModelOpen={isReportModelOpen}
                setIsPurchaseModelOpen={setIsReportModelOpen}
                queReportData={queReportData}
            />
        </div>
    )
}

export default QuestionSection